exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".asp-home{position:absolute;top:0;left:0;bottom:0;right:0;background-position:center;background-repeat:no-repeat;background-size:cover}", ""]);

